import React, { useState } from 'react';
import { useSearchAdminStorefrontSavedSearchProductsQuery } from '../../store/endpoints/StorefrontSettingsEndpoints';
import { IStorefrontProductView } from '../../models/StorefrontProducts';
import GridComposer from '../GridComposer/GridComposer';
import { GridSelectionMode, IColumnDetails } from '../../models/GridConfiguration';
import { PrimaryButton } from '@fluentui/react';
import SaveSearchPanel from '../Search/SaveSearchPanel';

interface StorefrontSavedSearchProductsAdminTableProps {
    storefront: string;
}

const StorefrontSavedSearchProductsAdminTable: React.FC<StorefrontSavedSearchProductsAdminTableProps> = ({ storefront }) => {
    const [page, setPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(25);
    const [filter, setFilter] = useState<string>();
    const [filterField, setFilterField] = useState<string>();
    const [sortBy, setSortBy] = useState<string>();
    const [sortDirection, setSortDirection] = useState<string>();
    const [selectedSavedSearchId, setSelectedSavedSearchId] = useState<string | undefined>();

    const conditions = { page, pageSize, searchTerm: filter, searchBy: filterField, sortBy, sortDirection };
    const productsQuery = useSearchAdminStorefrontSavedSearchProductsQuery(
        { storefrontId: storefront, conditions },
        { skip: !storefront }
    );

    const getCustomColumns = (): IColumnDetails[] => [
        {
            index: 0,
            identifier: 'details',
            label: '',
            type: '',
            component: (product: IStorefrontProductView) => (
                <PrimaryButton onClick={() => setSelectedSavedSearchId(product.savedSearchId)}>Details</PrimaryButton>
            ),
            required: true,
        },
    ];

    return (
        <div style={{ overflowX: 'auto' }}>
            <GridComposer
                data={productsQuery.data ?? {}}
                page={page}
                onPageChange={setPage}
                onPageSizeChange={setPageSize}
                loading={productsQuery.isLoading || productsQuery.isFetching}
                onRefresh={() => productsQuery.refetch()}
                selectionMode={GridSelectionMode.none}
                columnSetName={'StorefrontProduct'}
                filter={filter}
                filterField={filterField}
                sortBy={sortBy}
                sortDirection={sortDirection}
                onSort={(column, direction) => {
                    setSortBy(column);
                    setSortDirection(direction);
                }}
                onFilter={(f, column) => {
                    setFilter(f);
                    setFilterField(column);
                }}
                overrideColumns={getCustomColumns()}
                canDragColumns={true}
                canResizeColumns={true}
                canCustomizeColumns={true}
                canChangePageSize={true}
                canCreateCsv={true}
                getItemId={(item: IStorefrontProductView) => item.id}
            />

            {selectedSavedSearchId && (
                <SaveSearchPanel
                    savedSearchId={selectedSavedSearchId}
                    closer={() => setSelectedSavedSearchId(undefined)}
                />
            )}
        </div>
    );
};

export default StorefrontSavedSearchProductsAdminTable;
